import * as React from "react";
import { useState } from "react";
import { ColorGradeOption } from "../../../PreJobChecklistV2/colorGradeHelpers";
import { Collapse, Pressable } from "../../../ui";
import { InvoicedService } from "../../vehicleHistoryData";
import { InvoicedServiceRow } from "../../InvoicedServiceRow";
import { COLUMNS, INVOICED_BLUE, InvoicedMark, MARK_LABELS } from "../inspectionSummary.utils";
import { ReadingCells } from "../ReadingCells";
import { InvoicedCell } from "../InvoicedCell";

let nextRowId = 0;

// With invoiced services the whole row opens in place (no arrow: the blue check marks it).
export const Row: React.FC<{
  label: string;
  value?: string | null;
  grade?: ColorGradeOption | null;
  mark?: InvoicedMark | null;
  services?: InvoicedService[];
}> = ({ label, value, grade, mark, services = [] }) => {
  const [open, setOpen] = useState(false);
  const [servicesId] = useState(() => `inspection-row-services-${(nextRowId += 1)}`);
  if (!value) return null;
  const rowClass = "grid items-center gap-2 py-2 w-full text-left";
  if (!services.length) {
    return (
      <div className={`${rowClass} border-b border-[#44576e] last:border-b-0`} style={{ ...COLUMNS, minHeight: 44 }}>
        <ReadingCells label={label} value={value} grade={grade} />
        <InvoicedCell mark={mark} />
      </div>
    );
  }
  return (
    <div className="border-b border-[#44576e] last:border-b-0">
      <Pressable
        aria-expanded={open}
        aria-controls={servicesId}
        // The label replaces the row's content for screen readers, so it repeats the severity and the mark.
        aria-label={`${label}: ${[grade && `${grade} severity`, value, mark && MARK_LABELS[mark]]
          .filter(Boolean)
          .join(", ")}. ${open ? "Hide" : "Show"} invoiced services`}
        onClick={() => setOpen((current) => !current)}
        className={rowClass}
        // Inline: the button's own reset (no padding) would win over the row's py-2, making it shorter than the rest.
        style={{
          ...COLUMNS,
          display: "grid",
          justifyContent: "stretch",
          paddingTop: 8,
          paddingBottom: 8,
          minHeight: 44,
        }}
      >
        <ReadingCells label={label} value={value} grade={grade} />
        <InvoicedCell mark={mark} />
      </Pressable>
      <Collapse open={open}>
        {/* An alert-like box: the Invoiced check's blue border on a muted blue-grey near the card header's. */}
        <div
          id={servicesId}
          className="px-3 py-1 mb-2 rounded-md"
          style={{ border: `1px solid ${INVOICED_BLUE}`, backgroundColor: "#1c2e4a" }}
        >
          {services.map((service, index) => (
            <InvoicedServiceRow key={`${index}-${service.name}`} service={service} />
          ))}
        </div>
      </Collapse>
    </div>
  );
};
